<template>
  <div>
    <el-dialog title="提示" :visible.sync="value" width="870px" :before-close="handleClose">
      <template slot="title">
        <div class="header">
          <div class="publish_time">
            职位发布时间：{{ position_info.time }}
          </div>
        </div>
      </template>
      <div>
        <div class="title">职位基本信息</div>
        <div class="basic_info_box">
          <div v-for="item in basic_info" class="info_item" :key="item.key">
            <div class="left_label">{{ item.label }} :</div>
            <div class="right_value" v-if="item.label!='职位描述'">{{ item.value }}</div>
            <div class="right_value" v-else v-html="item.value"></div>
          </div>
        </div>
        <div class="title">职位要求</div>
        <div class="basic_info_box">
          <div v-for="item in postion_Requirements" class="info_item" :key="item.label">
            <div class="left_label">{{ item.label }} :</div>
            <div class="right_value">{{ item.value }}</div>

          </div>
        </div>

      </div>

    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["value", "position_info"],
  data() {
    return {
      job_info: {},
      basic_info: [
        {
          label: "公司",
          key: "company_mame",
          value: "",
        },
        {
          label: "招聘类型",
          key: "recruitment_type",
          value: "",
        },
        {
          label: "职位名称",
          key: "name",
          value: "",
        },
        {
          label: "职位描述",
          key: "position_introduction",
          value: "",
        },
        {
          label: "职位类型",
          key: "position_type",
          value: "",
        },
        {
          label: "工作地址",
          key: "address",
          value: "",
        },
      ],
      postion_Requirements: [
        {
          label: "经验与学历",
          value: "",
        },
        {
          label: "薪资范围",
          value: "",
        },
        // {
        //   label: "职位关键词",
        //   value: "",
        // },
      ],
      typeOption: [
        {
          label: "社招全职",
          value: 1,
        },
        {
          label: "应届校园招聘",
          value: 2,
        },
        {
          label: "实习生招聘",
          value: 3,
        },
        {
          label: "兼职招聘",
          value: 4,
        },
      ],
    };
  },
  mounted() {
    // if (this.position_info.id) this.getDetial();
  },
  methods: {
    handleClose() {
      this.$emit("closeDrawer");
    },
    getDetial() {
      this.$httpcompany.axiosGetBy(
        this.$api.positionManagePositionDetail,
        { id: Number(this.position_info.id) },
        (res) => {
          if (res.code == 200) {
            Object.assign(this.job_info, res.data);
            this.basic_info.forEach((item) => {
              item.value = this.job_info[item.key];
              if (item.key == "recruitment_type") {
                item.value = this.typeOption.find(
                  (obj) => obj.value == item.value
                )?.label;
              } else if (item.key == "recruitment_type") {
                item.value =
                  this.job_info.province +
                  this.job_info.city +
                  this.job_info.district +
                  this.job_info.address;
              } else if (item.key == "position_introduction") {
                // getDesc
                item.value = this.getDesc(item.value);
              }
            });

            // degree
            this.postion_Requirements[0].value =
              this.position_info.experience_type +
              "·" +
              this.position_info.degree;
            this.postion_Requirements[1].value = this.position_info.salary;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        }
      );
    },
    getDesc(desc) {
      return desc.replace(/\n/g, "<br>");
    },
  },
};
</script>
<style lang='scss' scoped>
.title {
  position: relative;
  padding-left: 10px;
  font-weight: 400;
  font-size: 18px;
  color: #444444;

  /* 为了给竖条留出空间 */
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 3px;
    height: 100%;
    background: #685ef5;
    /* 竖条的颜色 */
    border-radius: 4px;
  }
}
.basic_info_box {
  .info_item {
    display: flex;
    align-items: flex-start;
    margin: 16px 0;
    .left_label {
      width: 180px;
      text-align: right;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #9fa3af;
      padding-right: 10px;
      box-sizing: border-box;
    }
    .right_value {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #414a60;
      width: 335px;
    }
  }
}
</style>
